module.exports = __webpack_public_path__ + "img/menu-white.c789fc34.svg";